import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import { AttendancePolicyData, CommonReducerAction, setHelperText } from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import TextArea from "../../../../../Component/Material-ui/TextArea";
import { isSpaceInString } from "Utils";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class NameDesc extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attendancepolicyname: null,
      description: null,
      attendancepolicyid: null,
      notUnique: true,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("attendancepolicy,navigation");
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    const { InitAttendancePolicy } = this.props;
    this.props.onRef({
      onNext: this.validateNext,
    });
    this.setState({
      attendancepolicyname: InitAttendancePolicy.attendancepolicyname,
      description: InitAttendancePolicy.description,
      attendancepolicyid: InitAttendancePolicy.attendancepolicyid,
      notUnique:
        InitAttendancePolicy.attendancepolicyid == null
          ? false
          : !InitAttendancePolicy.attendancepolicyname,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(1, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  checkUnique(goNext = false) {
    if (
      this.state.attendancepolicyname
      && this.state.attendancepolicyname.trim() != ""
    ) {
      instance
        .post("/attendance/uniqueattendancepolicy", {
          name: this.state.attendancepolicyname,
          id: this.props.InitAttendancePolicy.attendancepolicyid,
        })
        .then(() => {
          this.setState({ notUnique: false }, () => {
            this.props.StepError(1, false);
            const { InitAttendancePolicy } = this.props;
            InitAttendancePolicy.attendancepolicyname = this.state.attendancepolicyname;
            this.props.AttendancePolicyData({ ...InitAttendancePolicy });
            if (goNext === true) this.props.click();
          });
        })
        .catch(() => {
          this.setState({ notUnique: true }, () => {
            this.props.StepError(1, true);
          });
          // this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: 'error' })
        });
    } else {
      this.setState({ notUnique: true }, () => {
        this.props.StepError(1, true);
      });
    }
  }

  onNameChange(event) {
    this.setState({ attendancepolicyname: event.target.value });
  }

  onDescChange(event) {
    this.setState({ description: event.target.value }, () => {
      const { InitAttendancePolicy } = this.props;
      InitAttendancePolicy.description = this.state.description;
      this.props.AttendancePolicyData({ ...InitAttendancePolicy });
    });
  }

  setHelperText = (key) => {
    const text = get(this.props, `Language.attendancepolicy[${key}]`, "");
    this.props.setHelperText({ helperText: text, open: true });
    // this.props.setHelperText({ helperText: this.props.Language ? this.props.Language.attendancepolicy[key] : "" })
  };

  validateNext = () => {
     if (this.state.attendancepolicyname && !isSpaceInString(this.state.attendancepolicyname)) {
      this.state.attendancepolicyname = this.state.attendancepolicyname.trim();
    }

    this.checkUnique(true);
    // if (!this.props.InitAttendancePolicy.attendancepolicyname) {
    //     // if (!this.state.attendancepolicyname || this.state.attendancepolicyname == '') {
    //     // this.props.enqueueSnackbar("Please Select unique policy name", { variant: 'error' })
    //     this.props.StepError(1, true)
    //     this.setState({ notUnique: true })
    // }
    // else {
    //     this.props.click()
    //     this.props.StepError(1, false)
    // }
  };

  render() {
    const language = this.props.Language.attendancepolicy;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="stepper-scroller padding-top-0">
          <div className="padding-bottom-30 stepper-scroller-content">
            <p className="input-form-label"></p>
            <div className="device-wrapper">
              <p className="form-input-label">
                <FormattedMessage
                  id="LbPolicyName"
                  defaultMessage="Policy Name"
                />
              </p>
              <div>
                <TextField
                  id="outlined-dense"
                  margin="dense"
                  variant="outlined"
                  autoComplete="off"
                  style={{ width: "100%" }}
                  placeholder="Enter Policy Name"
                  onChange={this.onNameChange.bind(this)}
                  value={this.state.attendancepolicyname}
                  onBlur={this.checkUnique.bind(this, false)}
                  onFocus={() => this.setHelperText("HtPolicyName")}
                  maxLength="100"
                  className="form-text-input"
                  autoFocus
                />

                <br />
                {this.state.notUnique ? (
                  <span className="caption-error">
                    *Please select a unique name
                  </span>
                ) : null}
              </div>
            </div>
            <div className="padding-bottom-30 device-wrapper">
              <p className="form-input-label">
                <FormattedMessage
                  id="LbDesciption"
                  defaultMessage="Lets write a brief description about this policy"
                />
              </p>
              <div>
                {/* <textarea
                  className="input-area-section"
                  placeholder="Description"
                  maxLength="200"
                  onChange={this.onDescChange.bind(this)}
                  value={this.state.description}
                  onFocus={() => this.setHelperText("HtDesciption")}
                ></textarea> */}
                <TextArea
                  className="width100"
                  maxLength="200"
                  variant="outlined"
                  placeholder="Description "
                  multiline
                  onChange={this.onDescChange.bind(this)}
                  value={this.state.description}
                  onFocus={() => this.setHelperText("HtDesciption")}
                />
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

NameDesc.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitAttendancePolicy: state.InitAttendancePolicy,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      AttendancePolicyData: (data) => AttendancePolicyData(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(NameDesc)));
